import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appChangeText]',
    standalone: false
})
export class ChangeTextDirective {
  constructor(private el: ElementRef, private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!this.ngControl.control) {
      return;
    }
    // Remove whitespace
    const newValue = input.value.replace(/\s+/g, '');
    // Update form control
    this.ngControl.control.setValue(newValue, { emitEvent: false });
    // Trigger validation
    this.ngControl.control.updateValueAndValidity();
  }

  // @HostListener('blur', ['$event'])
  // onBlur(event: KeyboardEvent) {
  //   this.trimText();
  // }
  // private trimText() {
  //   this.el.nativeElement.value = this.el.nativeElement.value.replace(/\s/g, '');
  // }
}
